export default {
  init() {

    var $plus  = $('.plus');
    var $minus = $('.minus');

    $plus.click(function(){
      var $qty   = $(this).siblings('.js-qty');
      var $val   = $qty.val();
      $qty.val( parseInt( $val ) + 1 );
    });

    $minus.click(function(){
      var $qty   = $(this).siblings('.js-qty');
      var $val   = $qty.val();

      if( parseInt( $val ) <= 1 ) {
        $qty.val(1);
      } else {
        $qty.val( parseInt( $val ) - 1 );
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js